import React from "react"
import { auditShape } from "utils/propTypeShapes"
import { AuditedUser } from "shared/audits"

const ConversationCreatedAuditItemDetails = ({ audit }) => {
  const { auditedChanges } = audit
  const { title } = auditedChanges

  return (
    <div>
      <span>
        <AuditedUser audit={audit} /> created a
        conversation titled <span className="font-semibold">{title}</span>.
      </span>
    </div>
  )
}

ConversationCreatedAuditItemDetails.propTypes = {
  audit: auditShape.isRequired,
}

export default ConversationCreatedAuditItemDetails
